import { css } from 'styled-components';

export default css`
  /* Vendor Fix */
  .swal2-styled:focus {
    box-shadow: none;
  }
`;
